import { render, staticRenderFns } from "./EditCompanyInfo.vue?vue&type=template&id=2050cc0a&"
import script from "./EditCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./EditCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditCompanyInfo.vue"
export default component.exports